import axios from 'axios';
import "./common"
import {baseUrl, BasicDataResponse, BasicResponse, TIMEOUT, User, UserListResponse, withCredentials} from "./common";
import {SafetyCheckOfOperation} from "../pages/Admin/Details/common";
import {
    NursingRecord, TotalProfile, Consumables, FaceDiagnosis, SurgicalInformedConsentForm,
    PostPrecautionForScarSurgery, ScarInjectionInformedConsentForm
} from "../pages/Admin/common";

// 创建axios示例，这里设置请求的默认配置
const instance = axios.create({
    timeout: TIMEOUT,
    baseURL: baseUrl,
    withCredentials: withCredentials,  //cros请求默认不带cookie信息，如果想要包含在请求中必须将属性置为true。线上环境不带，开发环境带
})

// 文档统一设置请求头
instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.get['Content-Type'] = 'application/json';

// 添加请求拦截器
instance.interceptors.request.use(config => {
    return config;
}, error => {
    return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(
    response => {
        if (response.status === 200) {
            // console.log("status 200", response)
            return Promise.resolve(response.data);
        } else if (response.status === 302) {
            // 浏览器会自动处理302的重定向，不会执行到这一步
            let redirectUrl = response.headers['location'];
            window.location.href = redirectUrl
        }
        return Promise.resolve(response.data.msg)
    },
    error => {
        if (error.response && error.response.status === 401) {
            const redirectUrl = error.response.headers['redirecturl'];
            if (redirectUrl) {
                // 重定向到返回的路径
                window.location.href = redirectUrl; // 或者使用 window.location.replace(redirectUrl);
            }
        } else if (error.response && error.response.status === 404) {
            window.location.href = baseUrl
        }
        return Promise.reject(error);
    }
)

export default instance;


/**
 * 生成年月日字符串
 */
function generateDateStr() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    // 0~9月前面加0
    let monthStr = String(month);
    if (monthStr.length < 2) {
        monthStr = "0" + monthStr;
    }

    // 天小于9的前面补零
    let dayStr = String(day);
    if (day < 9) {
        dayStr = "0" + dayStr;
    }

    return String(year) + monthStr + dayStr;
}

/**
 * 下载安全核查表
 * @param totalProfile
 */
export function safetyCheckOfOperationDownload(totalProfile: SafetyCheckOfOperation) {
    const ret: Promise<Blob> = instance.post("/api/downloadSafetyCheckDocx", totalProfile, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "安全核查表_" + totalProfile.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 下载手术护理记录单
 * @param totalProfile
 */
export function nursingRecordOfOperationDownload(totalProfile: NursingRecord) {
    const ret: Promise<Blob> = instance.post("/api/downloadNursingRecordDocx", totalProfile, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "护理记录单_" + totalProfile.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 上传数据下载生成病例。
 * @param totalProfile
 */
export function fileDownLoad(totalProfile:TotalProfile) {
    const ret: Promise<Blob> = instance.post("/api/downloadDocx", totalProfile, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "手术病历_" + totalProfile.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 下载手术消耗明细表
 * @param consumable
 * @constructor
 */
export function ConsumableFileDownLoad(consumable: Consumables) {
    const ret: Promise<Blob> = instance.post("/api/downloadConsumableDocx", consumable, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "消耗明细_" + consumable.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 下载疤痕面诊单
 * @param faceDiagnosis
 * @constructor
 */
export function FaceDiagnosisFileDownLoad(faceDiagnosis: FaceDiagnosis) {
    const ret: Promise<Blob> = instance.post("/api/downloadFaceDiagnosisDocx", faceDiagnosis, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "疤痕面诊单明细_" + faceDiagnosis.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 下载手术知情同意书
 * @param surgicalInformedConsentForm
 * @constructor
 */
export function SurgicalInformedConsentFileDownLoad(surgicalInformedConsentForm: SurgicalInformedConsentForm) {
    const ret: Promise<Blob> = instance.post("/api/downloadSurgicalInformedConsentFormDocx", surgicalInformedConsentForm, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "手术知情同意书_" + surgicalInformedConsentForm.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 下载疤痕术后注意事项
 * @param postPrecautionForScarSurgery
 * @constructor
 */
export function PostoperativePrecautionsForScarSurgeryFileDownLoad(postPrecautionForScarSurgery: PostPrecautionForScarSurgery) {
    const ret: Promise<Blob> = instance.post("/api/downloadPostoperativePrecautionsForScarSurgeryDocx", postPrecautionForScarSurgery, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "疤痕术后注意事项_" + postPrecautionForScarSurgery.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 下载疤痕注射知情同意书
 * @param scarInjectionInformedConsentForm
 * @constructor
 */
export function ScarInjectionInformedConsentFileDownLoad(scarInjectionInformedConsentForm: ScarInjectionInformedConsentForm) {
    const ret: Promise<Blob> = instance.post("/api/downloadInformedConsentFormForSteroidScarInjectionDocx", scarInjectionInformedConsentForm, {
        responseType: "blob"
    });

    ret.then(res=> {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");

        // 生成病例名称。
        a.download = "疤痕注射知情同意书_" + scarInjectionInformedConsentForm.name + "_" + generateDateStr() + ".docx";
        a.href = href;
        a.click();
    })
}

/**
 * 获取用户列表
 * @param pageNum 页码，默认1
 * @param pageSize 每页条数，默认10
 * @param userName 用户名，默认空字符串
 */
export function getList(pageNum: number = 1, pageSize: number = 10, userName: string = "") :Promise<BasicDataResponse<UserListResponse>> {
    return instance.get("/api/user/getList", {
        params: {
            pageNum,
            pageSize,
            userName
        }
    });
}

/**
 * 创建用户
 * @param userCreateRequest 创建用户请求体
 */
export function createUser(userCreateRequest: User): Promise<BasicResponse> {
    return instance.post("/api/user/create", userCreateRequest);
}

/**
 * 更新用户
 * @param userUpdateRequest 更新用户请求体
 */
export function updateUser(userUpdateRequest: User): Promise<BasicResponse> {
    return instance.post("/api/user/update", userUpdateRequest);
}

/**
 * 删除用户
 * @param id 用户ID
 */
export function deleteUser(id: number | string): Promise<BasicResponse> {
    return instance.get("/api/user/delete", {
        params: {
            id
        }
    });
}

/**
 * 校验用户是否是管理员
 * @param id 用户ID
 */
export function checkIsAdmin(id: number | string): Promise<BasicDataResponse<boolean>> {
    return instance.get("/api/user/isAdmin");
}